import { ChangeDetectionStrategy, Component, inject, TemplateRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

import {
  RouteTabGroupComponent,
  TabGroupConfig,
} from '@features/tab-group/route-tab-group.component';

import { SitesService } from '@models/sites/sites.service';

import { ROUTING_PATH } from '@shared/constants/routingPath';
import { LaunchDarklyService } from '@shared/services/launch-darkly.service';
import { AuthService } from '@shared/store/auth/auth.service';
import { EventQuery } from '@shared/store/event/event.query';
import { WorkflowQuery } from '@shared/store/workflow/workflow.query';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouteTabGroupComponent, RouterOutlet],
  selector: 'aux-patient-drivers',
  templateUrl: './patient-drivers.component.html',
})
export class PatientDriversComponent {
  authService = inject(AuthService);
  eventQuery = inject(EventQuery);
  launchDarklyService = inject(LaunchDarklyService);
  sitesService = inject(SitesService);
  workflowQuery = inject(WorkflowQuery);

  rightSideContainer = new BehaviorSubject<null | TemplateRef<unknown>>(null);
  tabs: TabGroupConfig[] = [
    {
      label: 'Patient Curves',
      route: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.PATIENT_DRIVER.CURVES,
    },
    {
      label: 'Patient Groups',
      route: ROUTING_PATH.FORECAST_ROUTING.DRIVERS.PATIENT_DRIVER.GROUPS,
      show: this.launchDarklyService.select$((flags) => flags.tab_patient_groups),
    },
  ];

  constructor() {
    this.sitesService.get().pipe(takeUntilDestroyed()).subscribe();
  }
}
